module.exports = __webpack_public_path__ + "static/img/bi.7056936.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gameBenefits/bi.png
// module id = OuDa
// module chunks = 1